import { useAPI } from '../hooks/useAPI';
import type { KpiList } from '../types';
import { MetricCard } from './shared/MetricCard';
import { formatPercent } from '../utils/format';

function displayValue(unit: string, value: number): string {
  if (unit === '%') return formatPercent(value, 1);
  if (unit === 'x') return `${value.toFixed(1)}x`;
  if (unit === 'days') return `${value.toFixed(1)} days`;
  if (unit === 'score') return value.toFixed(0);
  return String(value);
}

export function KPISummary() {
  const { data, loading, error } = useAPI<KpiList>('/api/kpis');

  if (loading) return <p className="text-slate-500">Loading KPIs…</p>;
  if (error) return <p className="text-rose-600">Failed to load KPIs: {error}</p>;
  if (!data) return null;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {data.items.map((kpi) => (
        <MetricCard
          key={kpi.metric_key}
          label={kpi.metric_label}
          value={displayValue(kpi.unit, kpi.value)}
          hint={
            kpi.target !== null
              ? `Target: ${displayValue(kpi.unit, kpi.target)}`
              : undefined
          }
          tone={kpi.on_target === null ? 'neutral' : kpi.on_target ? 'good' : 'bad'}
        />
      ))}
    </div>
  );
}
